import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

export function SAStepTemplatesFeatureGate(props: Props) {
    return (
        <FeatureGateModalWrapper
            isOpen={props.isOpen}
            onClose={() => props.setIsOpen(false)}
            title='Set up automated tasks to keep your sales team on track, wherever leads are in the pipeline'
            description='Help your team maintain momentum with automated task reminders that will keep leads moving in the right direction.'
            bullets={[
                'Design your perfect sales process and set up recurring tasks and reminders.',
                'Define tasks to be completed for each stage in your pipeline.',
                'Set due dates and give tasks descriptions to set your team up for success.',
            ]}
            feature='salesAutomationTasks'
        />
    );
}
